// External Imports
import { DropdownMenuItem as DSDropdownMenuItem, styled } from '@lessonnine/design-system.lib';

// Internal Imports
import { withLinkLogic } from './withLinkLogic.jsx';

// Component Definition
const DropdownMenuItem = styled(withLinkLogic(DSDropdownMenuItem))`
  text-decoration: none;
`;

// Module Exports
export { DropdownMenuItem };
